import {
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

export const productAccessorIsSellerPromotionWithVoucherCode = (
  sellerPromotion: SellerPromotionV2,
): boolean =>
  Boolean(sellerPromotion.voucherCode) &&
  (sellerPromotion.discountType === OfferDiscountTypeEnumV2.TotalPercent ||
    sellerPromotion.discountType === OfferDiscountTypeEnumV2.TotalAmount)
